/* =====================================================================
   UUGI Code of Conduct — code-of-conduct.js
   Only responsibility: reveal-on-scroll for .reveal elements, matching the
   behaviour of the other v4 subpages (people.js, umbrashow.js). Shared nav /
   burger behaviour is handled by v4-ui.js.
   ===================================================================== */
(function () {
  'use strict';

  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.06, rootMargin: '0px 0px -36px 0px' });
      els.forEach(function (el) { io.observe(el); });

      /* Safety net: anything still hidden after 1.2s (e.g. above-the-fold
         hero content that never fires an intersection) is force-shown. */
      setTimeout(function () {
        document.querySelectorAll('.reveal:not(.is-visible)').forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.top < window.innerHeight) el.classList.add('is-visible');
        });
      }, 1200);
    } else {
      els.forEach(function (el) { el.classList.add('is-visible'); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }
})();
